var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-tabbed-page"},[_c('div',{staticClass:"station-tag-content"},[_vm._t("tabcontent")],2),_c('div',{staticClass:"station-tab-bar"},[_vm._t("tablist")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }